// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_modules_homePage_js") return "./js/chunks/ab9cbabecbd9313bf489.js";
	if (chunkId === "vendors-node_modules_swiper_swiper-bundle_mjs") return "./js/chunks/e2aceb427b44e6c797f8.js";
	if (chunkId === "assets_js_modules_sliderDirector_js") return "./js/chunks/836a5519c0b8fcdb5ecb.js";
	if (chunkId === "assets_js_modules_sliderEditor_js") return "./js/chunks/0ce656887a1e4b2f4f10.js";
	if (chunkId === "assets_js_modules_theme_js") return "./js/chunks/800c7f5506d278c7fea6.js";
	if (chunkId === "assets_js_modules_underlink_js") return "./js/chunks/0ed13a9de46418eff387.js";
	// return url for filenames based on template
	return undefined;
};